import React from 'react';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';

// export const NoEffectButton =  styled(Button)`
// &:hover {
//   background-color: transparent;
// }
// `;

export const NoEffectButton = styled(Button)(({ theme }) => ({
  padding: 0,
  margin: 0,
  "&:hover": {
      backgroundColor: "transparent",
    }
}));